// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkSelectorUpload-cls1_1pm","cls2":"WorkSelectorUpload-cls2_cLf WorkSelectorUpload-cls1_1pm"};